module.exports = __webpack_public_path__ + "static/20-5-530026b24921f7cce8701a3525242e24.jpg";